// Wipe+ helpers — pure derivation from a user record. The source of
// truth is `users.wipe_plus_until`, maintained by a trigger on the
// `subscriptions` table (see supabase/migrations/020_wipe_plus.sql).
//
// We never compute this client-side from the subscriptions table
// directly because the heatmap, post header, leaderboard, and profile
// page all need to know "is this OTHER user a subscriber?" — and they
// already have a `users` row in hand. The single column avoids a join
// per row.

import { useContext } from 'react';
import { AuthContext, MyContext } from '../context/AuthContext';

interface UserShape {
  wipe_plus_until?: string | null;
}

export function isWipePlus(record: UserShape | null | undefined): boolean {
  if (!record?.wipe_plus_until) return false;
  return new Date(record.wipe_plus_until).getTime() > Date.now();
}

export function wipePlusExpiresAt(record: UserShape | null | undefined): Date | null {
  if (!record?.wipe_plus_until) return null;
  const d = new Date(record.wipe_plus_until);
  return isFinite(d.getTime()) ? d : null;
}

export function useWipePlus(): { isPlus: boolean; expiresAt: Date | null } {
  const { userRecord } = useContext<MyContext>(AuthContext);
  return {
    isPlus: isWipePlus(userRecord),
    expiresAt: wipePlusExpiresAt(userRecord),
  };
}
